import { ProcessingRuleItem, useMutation, useQueryClient } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';
import { useSnackbar } from '@/modules/core/hooks';
import { QUERY_KEY } from '@/modules/ProcessingDefinition/ProcessingRule/queries/useProcessingRules.query';

import { useProcessingRulesParamsStore } from '../../stores';

interface TierPayload {
  name: string;
  payout_definition_id: string;
  triggers?: string[];
}
interface ProcessingRulePayloadBody {
  name: string;
  organization_id?: string;
  tiers: TierPayload[];
}
const useCreateProcessingRuleQuery = (
  updatedElement?: ProcessingRuleItem,
  onSuccess?: (ruleId: string, ruleName: string) => void
) => {
  const { handleAddPermanentSnackbar } = useSnackbar();
  const setNewId = useProcessingRulesParamsStore((state) => state.setNewItemId);
  const queryClient = useQueryClient();
  const { mutateAsync, isLoading } = useMutation(
    (payload: ProcessingRulePayloadBody) =>
      updatedElement
        ? api.put(API_URL.PROCESSING_RULES_BY_ID(updatedElement?.id), payload)
        : api.post(API_URL.PROCESSING_RULES, payload),
    {
      onSuccess: (data) => {
        const ruleId = `${data.data.id || ''}`;
        const ruleName = data?.data?.name || '';
        setNewId(ruleId);
        handleAddPermanentSnackbar({
          text: `${updatedElement ? 'Edited' : 'Created'} ${ruleName} rule`,
          closeIcon: true,
        });
        queryClient.invalidateQueries({ queryKey: [QUERY_KEY] });

        if (onSuccess) {
          onSuccess(ruleId, ruleName);
        }
      },
    }
  );

  return { mutateAsync, isLoading };
};

export default useCreateProcessingRuleQuery;
